export default __webpack_public_path__ + "addUser.html";